export const loadChunkSize = 51
